"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("./api.js");
var _internal = require("@/components/uploadPicture/internal.js");
var _validate = require("@/utils/validate.js");
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var _fliterConfig = _interopRequireDefault(require("./fliterConfig.js"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // 导入本地上传工具函数
var _default = exports.default = {
  data: function data() {
    return _objectSpread(_objectSpread(_objectSpread({
      JavaInfo: false,
      homeType: false,
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        type: '0'
      }
    }, (0, _fliterConfig.default)({
      handleSearch: this.handleSearch
    })), (0, _paginationEffect.default)(this.getList)), {}, {
      auditSpuOrSkuRef: '',
      priceAdjustmentItemRef: ''
    });
  },
  created: function created() {
    var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
    this.homeType = JavaInfo.homeType === 2;
    var homeTypeInfo = this.$getHomeType();
    this.homeType = homeTypeInfo ? Number(homeTypeInfo.type) === 2 : false;
    this.getList();
  },
  methods: {
    //审核
    auditItem: function auditItem(id) {
      this.$refs.auditSpuOrSkuRef.setOpen(id, 'SKU');
      // console.log(this.$refs.auditSpuOrSkuRef)
    },
    //调价记录
    priceAdjustmentItem: function priceAdjustmentItem(id) {
      this.$refs.priceAdjustmentItemRef.setOpen(id, 'SKU');
    },
    handleSearch: function handleSearch(data) {
      if (data) {
        this.tableFrom = _objectSpread(_objectSpread({}, this.tableFrom), data);
      } else {
        this.tableFrom = {
          type: '0'
        };
      }
      this.resetPageData();
    },
    //采销状态
    handleCpStatus: function handleCpStatus(row) {
      this.$refs.ChanageCpStatusRef.open(row);
    },
    // 导出
    resultExports: function resultExports() {
      (0, _api.productExcelApi)(this.tableFrom).then(function (res) {
        window.location.href = res.fileName;
      });
    },
    // 对外导出
    foreignExports: function () {
      var _foreignExports = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _api.productOutApi)(this.tableFrom);
            case 1:
              res = _context.v;
              window.open(res.fileName);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function foreignExports() {
        return _foreignExports.apply(this, arguments);
      }
      return foreignExports;
    }(),
    // 同步产品库
    updateProductLibrary: function () {
      var _updateProductLibrary = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _api.skuSyncProductApi)();
            case 1:
              this.$message.success('同步成功');
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function updateProductLibrary() {
        return _updateProductLibrary.apply(this, arguments);
      }
      return updateProductLibrary;
    }(),
    // 上传
    uploadFile: function () {
      var _uploadFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(file) {
        var formData, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              _context3.n = 1;
              return (0, _api.uploadChangePriceApi)(formData);
            case 1:
              res = _context3.v;
              this.$message.success('上传成功！');
              this.getList();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function uploadFile(_x) {
        return _uploadFile.apply(this, arguments);
      }
      return uploadFile;
    }(),
    // 列表
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _api.skuListApi)(_objectSpread(_objectSpread({}, this.tableFrom), this.pageData)).then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        _this2.listLoading = false;
      }).catch(function (err) {
        _this2.listLoading = false;
        _this2.$message.error(err);
      });
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this3 = this;
      this.$modalSure("\u5220\u9664\u6570\u636E\u5C06\u4E0D\u80FD\u6062\u590D\uFF0C\u786E\u8BA4\u5220\u9664\u5417\uFF01").then(function () {
        (0, _api.deleteByIdApi)({
          id: id
        }).then(function () {
          _this3.$message.success('删除成功');
          _this3.getList();
        });
      });
    },
    onchangeListStatus: function () {
      var _onchangeListStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(row) {
        var params, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              params = {
                id: row.id,
                status: row.listStatus
              };
              _context4.p = 1;
              _context4.n = 2;
              return (0, _api.updateStatusApi2)(params);
            case 2:
              this.$message.success('操作成功');
              this.getList();
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t = _context4.v;
              row.listStatus = !row.listStatus;
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function onchangeListStatus(_x2) {
        return _onchangeListStatus.apply(this, arguments);
      }
      return onchangeListStatus;
    }(),
    inputSort: (0, _validate.Debounce)(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var params, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              params = {
                id: row.id,
                sort: row.sort
              };
              _context5.p = 1;
              _context5.n = 2;
              return (0, _api.updateSortApi)(params);
            case 2:
              this.getList();
              this.$message.success('排序成功');
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t2 = _context5.v;
              this.getList();
              this.$message.error(_t2);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      return function (_x3) {
        return _ref.apply(this, arguments);
      };
    }()),
    inputStock: (0, _validate.Debounce)(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        var params, _t3;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              params = {
                id: row.id,
                stock: row.stock
              };
              _context6.p = 1;
              _context6.n = 2;
              return (0, _api.updateStockApi)(params);
            case 2:
              this.getList();
              this.$message.success('修改成功');
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t3 = _context6.v;
              this.getList();
              this.$message.error(_t3);
            case 4:
              return _context6.a(2);
          }
        }, _callee6, this, [[1, 3]]);
      }));
      return function (_x4) {
        return _ref2.apply(this, arguments);
      };
    }()),
    previewImg: function previewImg(img) {
      //预览图片
      this.$previewImg({
        imageList: [img]
      });
    },
    // 上传图片 - 使用Windows本地文件目录的方式，调用API接口
    modalPicTap: function modalPicTap(productForm) {
      var imageField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'attrImage';
      var _this = this;

      // 使用工具函数上传图片
      window.$loading = this.$loading;
      (0, _internal.uploadLocalImage)({
        multiple: false,
        model: 'product',
        pid: 1,
        onSuccess: function onSuccess(url) {
          // 上传成功，添加到图片列表
          productForm[imageField] = url;

          // 更新UI
          _this.$nextTick(function () {
            _this.$forceUpdate();
          });
          _this.$message.success('图片上传成功');
        },
        onError: function onError(error) {
          _this.$message.error(error.message || '上传失败');
        }
      });
    }
  }
};